<template>
  <div>
    <tsl-card :cardList="cardList">
      <template v-slot:access>
        <div class="access-ontrol">
          <div class="item" v-for="(item, index) in overviewList" :key="index">
            <devops-card :name="item.name" :value="item.value" :path="item.path"></devops-card>
            <div class="create button-base">新建</div>
          </div>
        </div>
      </template>
      <template v-slot:topRight>
        <more-arrow path="/dashboard/devops/ram/overview" />
      </template>
    </tsl-card>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
import Dcard from "@/components/dashboard/devops/devops-card.vue";
import More from "@/components/more-arrow/index";
import { reactive, ref } from "vue";
export default {
  name: "access-ontrol",
  components: {
    [Card.name]: Card,
    [Dcard.name]: Dcard,
    [More.name]: More
  },
  props: {
    data: Object
  },
  setup() {
    const overviewList = ref([
      {
        name: "用户",
        value: 0,
        path: "/dashboard/devops/ram/user"
      },
      {
        name: "角色",
        value: 0,
        path: "/dashboard/devops/ram/role"
      },
      {
        name: "用户组",
        value: 0,
        path: "/dashboard/devops/ram/user-group"
      }
    ]);
    const cardList = reactive([
      {
        name: "access",
        title: "访问控制",
        topRight: "topRight"
      }
    ]);
    return {
      cardList,
      overviewList
    };
  }
};
</script>
<style scoped lang="less">
.access-ontrol {
  display: flex;
  .item {
    width: 100%;
    margin-right: 16px;
  }
  .item:nth-child(3n) {
    margin-right: 0;
  }
  .create {
    display: block;
    width: 48px;
    height: 24px;
    margin: 8px auto 0;
    line-height: 24px;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>
